import React, {useEffect} from 'react';
import TabDetails from '../components/TabDetails';
import VerticalTabs from '../../_common/components/VerticalTabs';
import {PriceQuoteDetailsProvider, usePriceQuoteDetailsContext} from '../contexts/PriceQuoteDetailsContext';
import {useHeader} from "../../../../_metronic/layout";
import {useIntl} from "react-intl";
import {useLocation} from "react-router-dom";
import {PageProvider, usePageContext} from "../contexts/PageContext";
import PopupCreateLink from "../components/PopupCreateLink/PopupCreateLink";
import {CreateLinkProvider} from "../contexts/CreateLinkContext";
import TabTempInspections from "../components/TabTempInspections";
import {TempInspectionsListProvider} from "../contexts/TempInspectionsListContext";
import {DecisionTreeOptionsContextProvider} from "../../_common/components/DecisionTreeOptions";
import TabCustomers from "../components/TabCustomers";

interface TabItem {
  id: string;
  label: string;
  content: React.ReactNode;
  icon?: string;
  disabled?: boolean;
  warning?: boolean;
}

const PriceQuoteDetails = () => {

  return (
    <PageProvider>
      <div className="pt-8">
        <PriceQuoteDetailsProvider>
          <DecisionTreeOptionsContextProvider>
            <TempInspectionsListProvider>
              <Container/>
            </TempInspectionsListProvider>
          </DecisionTreeOptionsContextProvider>
        </PriceQuoteDetailsProvider>
      </div>
      <CreateLinkProvider>
        <PopupCreateLink/>
      </CreateLinkProvider>
    </PageProvider>
  );
};

const Container = () => {
  const header = useHeader();
  const {formatMessage} = useIntl();
  const location = useLocation();
  const pathName: string = location.pathname;
  const priceQuoteID: string = pathName.replace('/price-quote-details/', '');
  const isNewDoc = priceQuoteID === '-1';
  const headerText = formatMessage({
    id: `price-quote-details-page-${isNewDoc ? 'create' : 'edit'}`,
    defaultMessage: `${isNewDoc ? 'Create' : 'Edit'}`
  });
  const pageHeader: string = [headerText, isNewDoc ? '' : priceQuoteID]
    .filter(Boolean).join(' - ');

  useEffect(() => {
    header.setTitle(pageHeader);
  }, [header, pageHeader]);

  const {tabsRef} = usePriceQuoteDetailsContext();
  const {isTab1Valid, isTab2Valid, isTab3Valid} = usePageContext();

  const tabs: TabItem[] = [
    {
      id: 'customers',
      label: 'לקוחות',
      content: <TabCustomers/>,
      icon: '/media/common/User.svg',
      warning: !isTab1Valid
    },
    {
      id: 'inspections',
      label: 'דוחות זמניים',
      content: <TabTempInspections/>,
      icon: '/media/common/Clipboard.svg',
      disabled: isNewDoc,
      warning: !isTab2Valid
    },
    {
      id: 'price-quote',
      label: 'הצעת מחיר',
      content: <TabDetails/>,
      icon: '/media/common/Price_quote.svg',
      disabled: isNewDoc,
      warning: !isTab3Valid
    },
  ];

  return <VerticalTabs tabs={tabs as unknown as never[]} ref={tabsRef}/>
}

export default PriceQuoteDetails;